import React, { useState, useEffect } from 'react';
import { X, Cookie } from 'lucide-react';
import { useTranslation } from '../context/TranslationContext';

// Compact corner toast (~320px) pinned to bottom-left so it never blocks the
// checkout form or shop CTAs. Dismissible. Previously this was a full-width
// bottom banner that covered ~10% of the viewport — bad for mobile conversion.
function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(function() {
    var consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      var timer = setTimeout(function() {
        setIsVisible(true);
      }, 2000);
      return function() { clearTimeout(timer); };
    }
  }, []);

  function acceptAll() {
    localStorage.setItem('cookieConsent', 'all');
    setIsVisible(false);
  }

  function acceptEssential() {
    localStorage.setItem('cookieConsent', 'essential');
    setIsVisible(false);
  }

  function dismiss() {
    // Soft-dismiss without storing a choice — the toast will reappear next visit.
    setIsVisible(false);
  }

  if (!isVisible) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed bottom-4 left-4 right-4 sm:right-auto sm:max-w-[340px] z-50 bg-neutral-900/95 backdrop-blur-xl border border-white/10 rounded-2xl shadow-2xl p-4"
      style={{ animation: 'fadeInUp 300ms ease-out' }}
    >
      <button
        onClick={dismiss}
        data-testid="cookie-dismiss-btn"
        className="absolute top-2 right-2 text-neutral-500 hover:text-white p-1 rounded-full hover:bg-white/5"
        aria-label="Dismiss"
      >
        <X className="w-3.5 h-3.5" />
      </button>

      <div className="flex items-start gap-3 mb-3 pr-4">
        <div className="w-8 h-8 rounded-full bg-[#d4af37]/20 flex items-center justify-center flex-shrink-0">
          <Cookie className="w-4 h-4 text-[#d4af37]" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-white font-semibold text-sm mb-0.5">{t('cookieTitle')}</h3>
          <p className="text-neutral-400 text-xs leading-snug">
            {t('cookieMessage')}
          </p>
        </div>
      </div>

      <div className="flex items-center gap-2">
        <button
          onClick={acceptEssential}
          data-testid="cookie-essential-btn"
          className="flex-1 px-3 py-1.5 rounded-full text-xs font-medium text-neutral-300 border border-white/20 hover:bg-white/10 transition-all"
        >
          {t('cookieEssential')}
        </button>
        <button
          onClick={acceptAll}
          data-testid="cookie-accept-btn"
          className="flex-1 px-3 py-1.5 rounded-full text-xs font-medium bg-[#d4af37] text-black hover:bg-white transition-all"
        >
          {t('cookieAccept')}
        </button>
      </div>
    </div>
  );
}

export default CookieConsent;
